import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/consumo',
  component: DashBoardNav,
  children: [
    {path: '/consumo', component: () => import('@/components/datalead/LeadManager')},
  //  {path: '/columnchooser', component: () => import('@/components/datalead/ColumnChooser')},
   // {path: '/columnchooserpurchase', component: () => import('@/components/datalead/ColumnChooserPurchase')},
  //  {path: '/columnchooserpurchase/:layer', name: 'datapurchase', component: () => import('@/components/datalead/ColumnChooserPurchase')}
  ]
}]
